import { createApi } from '@reduxjs/toolkit/query/react';
import { dynamicBaseQuery } from '~/api/common/dynamicBaseQuery';

const baseUrl: string = '/v1/admin/mmt-properties';

export const mmtManagementApi = createApi({
    reducerPath: 'mmtApi',
    baseQuery: dynamicBaseQuery,
    endpoints: (builder) => ({
        fetchVehicleEnergyTypes: builder.query<string[], void>({
            query: () => ({
                url: `${baseUrl}/vehicle-energy-types`,
                method: 'GET',
            }),
        }),
        fetchMmtHeadUnits: builder.query<string[], void>({
            query: () => ({
                url: `${baseUrl}/mmt-head-units`,
                method: 'GET',
            }),
        }),
        fetchFunctionKeys: builder.query<string[], void>({
            query: () => ({
                url: `${baseUrl}/function-keys`,
                method: 'GET',
            }),
        }),
    }),
});

export const {
    useFetchVehicleEnergyTypesQuery,
    useFetchMmtHeadUnitsQuery,
    useFetchFunctionKeysQuery,
} = mmtManagementApi;
